import React from "react";
import { Calendar } from "lucide-react";

const steps = [
  { label: "Week 1–2", title: "Appetite starts to settle", desc: "You notice smaller portions feel satisfying. Mild nausea in some — we manage it together on WhatsApp." },
  { label: "Month 1", title: "First 3–5 kg lost", desc: "Energy returns, cravings fade. We titrate the dose based on your response and tolerability." },
  { label: "Month 3", title: "8–15 kg cumulative", desc: "Clothes fit noticeably different. Labs repeat: A1c, lipids, liver — most trend healthier." },
  { label: "Month 6", title: "10–30 kg target range", desc: "Transition to a maintenance plan — lower dose or structured taper with sustainable habits." },
];

export const Timeline = () => {
  return (
    <section id="timeline" className="py-24 md:py-32 bg-[#242220] text-white relative overflow-hidden">
      <div aria-hidden className="absolute -top-20 -right-20 h-[420px] w-[420px] rounded-full bg-[#779D7C] blur-3xl opacity-60"></div>
      <div aria-hidden className="absolute bottom-0 -left-20 h-[340px] w-[340px] rounded-full bg-[#EB8771]/20 blur-3xl"></div>

      <div className="max-w-7xl mx-auto px-6 md:px-12 relative">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full bg-white/10 border border-white/20 px-3.5 py-1.5 text-xs font-medium text-[#E8F0E9]">
            <Calendar className="h-3.5 w-3.5" /> Your 6‑month timeline
          </span>
          <h2 className="mt-5 font-display text-4xl md:text-5xl leading-[1.05]">
            What to expect, <em className="text-[#EB8771]">week by week</em>.
          </h2>
          <p className="mt-5 text-white/75 leading-relaxed max-w-xl">
            Outcomes vary. These are typical milestones we see across our Mounjaro & GLP‑1 patients under Dr. Shalini's care.
          </p>
        </div>

        <div className="mt-14 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
          {steps.map((s, i) => (
            <div
              key={s.label}
              data-testid={`timeline-${i}`}
              className="rounded-3xl border border-white/15 p-7 bg-white/[0.04] hover:bg-white/[0.08] transition-colors"
            >
              <div className="flex items-center gap-3">
                <span className="h-7 w-7 grid place-items-center rounded-full bg-[#EB8771] text-white text-xs font-semibold">
                  {i + 1}
                </span>
                <span className="text-[11px] tracking-[0.18em] uppercase text-[#E8F0E9]">{s.label}</span>
              </div>
              <p className="font-display text-2xl mt-5">{s.title}</p>
              <p className="text-sm text-white/70 mt-2 leading-relaxed">{s.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};
